function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as r } from "react/jsx-runtime";
import { useIsInverseVariant as n } from "../../theme-variant-context.js";
import { vars as o } from "../../skins/skin-contract.css-mistica.js";
const l = (_param)=>{
    var { color: t , size: c = 24  } = _param, e = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const s = n(), i = t !== null && t !== void 0 ? t : s ? o.colors.inverse : o.colors.neutralHigh;
    return /* @__PURE__ */ r("svg", _object_spread_props(_object_spread({
        width: c,
        height: c,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: /* @__PURE__ */ r("path", {
            fill: i,
            d: "M9.932 11.263c-1.418 0-2.535-.383-3.32-1.137C5.794 9.339 5.38 8.19 5.38 6.714S5.794 4.09 6.61 3.3c.784-.762 1.904-1.149 3.322-1.149 1.417 0 2.537.387 3.325 1.143.82.79 1.235 1.941 1.235 3.417 0 1.477-.415 2.625-1.238 3.412-.785.757-1.902 1.14-3.322 1.14zM6.198 6.711c0 1.247.33 2.197.98 2.821.628.605 1.555.91 2.754.91 1.201 0 2.128-.305 2.759-.91.655-.624.986-1.577.986-2.82 0-1.244-.33-2.2-.986-2.827-.63-.608-1.558-.916-2.76-.916-1.198 0-2.125.308-2.753.916-.65.63-.98 1.58-.98 2.826zm15.63 14.737a.408.408 0 00-.39-.428H8.865a.408.408 0 00-.409.409c0 .226.182.409.41.409H21.44a.406.406 0 00.389-.39zM3.04 18.714a.062.062 0 01-.062-.061l.003-1.381c0-1.21.373-2.238 1.076-2.972.767-.801 1.924-1.224 3.347-1.224h1.151c-.061.224-.098.47-.098.747v4.261c0 .213.023.423.067.63H3.041zm7.563-6.196s9.064-.005 9.059-.003c.479 0 .823.104 1.028.314.199.202.3.535.3.992v4.255c0 .459-.101.798-.3 1.005-.208.213-.552.32-1.028.32l-9.065.005c-.476 0-.82-.106-1.025-.32-.199-.206-.3-.543-.3-1.002v-4.26c0-.309.05-.555.14-.748h.02v-.045a.823.823 0 01.14-.2c.207-.206.552-.313 1.03-.313zm-1.76 7.014v-.064c.018.023.034.047.05.07.03.041.058.082.088.117.367.379.91.572 1.616.572l9.065-.006c.708 0 1.252-.193 1.616-.571.35-.364.53-.894.53-1.572v-4.26c0-.675-.177-1.205-.53-1.563-.364-.373-.908-.56-1.613-.56L10.6 11.7c-.706 0-1.25.188-1.613.56H7.399c-1.65 0-3.01.51-3.938 1.477-.849.888-1.3 2.112-1.3 3.537v1.379c0 .484.395.88.883.88h5.8z"
        })
    }));
}, m = l;
export { m as default };
